import config from "site-config";

const churnZeroAppKey = config.CHURNZERO_APP_KEY;
const churnZeroScriptUrl = config.CHURNZERO_SCRIPT_URL;

export const initChurnZero = ({ callback }) => {
    if (!window.ChurnZero && config.CHURNZERO_APP_KEY && churnZeroScriptUrl) {
        const churnZeroScriptTag = document.createElement("script");
        churnZeroScriptTag.type = "text/javascript";
        churnZeroScriptTag.async = true;
        churnZeroScriptTag.src = churnZeroScriptUrl;
        const pageScript = document.getElementsByTagName("script")[0];
        pageScript.parentNode.insertBefore(churnZeroScriptTag, pageScript);

        churnZeroScriptTag.addEventListener("load", () => {
            // eslint-disable-next-line no-undef
            window.ChurnZero = ChurnZero; // this var is generated by ChurnZero script
            if (callback) {
                callback();
            }
        });
    }
};

export const setChurnZeroContact = ({ brand, me }) => {
    if (window.ChurnZero?.push && churnZeroAppKey) {
        // we always call a logout to account for brand changes
        logoutChurnZero();
        // after a logout, we need to reinitialize the configuration
        window.ChurnZero.push(["setAppKey", churnZeroAppKey]);
        window.ChurnZero.push(["setContact", brand._id, me._id]);

        window.ChurnZero.push(["setAttribute", "account", "Name", brand.name]);

        const [firstName, lastName] = me.name.split(" ");
        window.ChurnZero.push(["setAttribute", "FirstName", firstName]);
        window.ChurnZero.push(["setAttribute", "LastName", lastName]);
        window.ChurnZero.push(["setAttribute", "Email", me.email]);
    }
};

export const trackChurnZeroEvent = ({ name, description = null, quantity = null, customFields = null }) => {
    if (window.ChurnZero?.push && churnZeroAppKey) {
        window.ChurnZero.push(["trackEvent", name, description, quantity, customFields]);
    }
};

export const logoutChurnZero = () => {
    if (window.ChurnZero?.push) {
        window.ChurnZero.push(["trackEvent", "Logout"]);
        window.ChurnZero.push(["stop"]);
    }
};
